import { ProductInfoBoxOrder as CoreProductInfoBoxOrder } from 'core/components'
import { T, __ } from 'stylewhere/i18n'

export class ProductInfoBoxOrder extends CoreProductInfoBoxOrder {
  getBoxTitle = () => {
    return __(T.misc.work_order)
  }

  getOrderCode = () => {
    return 'productionOrder.attributes.numeroCommessa'
  }

  getAttributes = () => {
    return [
      {
        label: __(T.misc.material),
        path: 'productionOrder.attributes.material'
      },
      {
        label: __(T.custom.addon),
        path: 'productionOrder.attributes.addonCode'
      }
    ]
  }
}
